import { useQuery } from '@tanstack/react-query';

import { sdk } from '@/services';

const CourseService = sdk.getService('CourseService');

export const useSyncedActivitiesCourses = (activityId?: string) => {
  const { isLoading, data, error } = useQuery({
    queryKey: ['syncedActivitiesCourses', activityId],
    queryFn: () => CourseService.getSyncedActivitiesCourses(activityId!),
    enabled: !!activityId
  });

  return {
    syncedCourses: data ?? [],
    isLoading,
    error
  };
};
